var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatepicker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.a,.b{stroke:#661c69;}.b,.d{fill:none;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-935 -582)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(935 586)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 29,
    height: 25,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 28,
    height: 24,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(938 602)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 7,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 6,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(938 595)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 7,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 6,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(953 582)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 5,
    height: 8,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 4,
    height: 7,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(941 582)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 5,
    height: 8,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 4,
    height: 7,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(946 602)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 7,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 6,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(946 595)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 7,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 6,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(954 602)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 7,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 6,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(954 595)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 7,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 6,
    height: 5,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 28,
    transform: "translate(935.5 592.5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatepicker);
export default __webpack_public_path__ + "static/media/datepicker.9e1ffbad.svg";
export { ForwardRef as ReactComponent };